export const userItemPaidStatus = (auctionUser, auction) => {

  const userId = auctionUser?.UserId

  const userItems = {paid: [], unpaid: []}

  const itemDetails = auction?.Items
  const fixedDetails = auction?.FixedItems

  const userAuctionDetails = auctionUser.MyAuctions.find((ele) => ele.AuctionId === auction?.AuctionId)

  //add in unpaid bid items
  for (let i = 0; i < itemDetails?.length; i++) {
    let item = itemDetails[i]

    if (item.CurrentHighBidder === userId) {
      if (item.Paid === true) userItems.paid.push(item)
      else userItems.unpaid.push(item)
    }
  }

  // add unpaid fixed items
  for (let i = 0; i < fixedDetails?.length; i++) {
    let item = fixedDetails[i]

    const userPaidFor = item?.Payments?.reduce((sum, item) => {
      if (item?.UserId === userId) {
        return sum + item.Quantity
      } return sum
    }, 0)

    if (item.MyAmountPurchased > 0) {
      if (userPaidFor === item.MyAmountPurchased) userItems.paid.push(item)
      else userItems.unpaid.push(item)
    }
  }
  
  // add donations
  if (userAuctionDetails?.DonationTotal > 0) {
    if (userAuctionDetails?.DonationPayment) userItems.paid.push({Donation: userAuctionDetails.DonationTotal, Paid: true})
    else userItems.unpaid.push({Donation: userAuctionDetails.DonationTotal, Paid: false})
  }

  return userItems
}

export const calculateUserBalance = (auctionUser, auction) => {

  const oweItems = userItemPaidStatus(auctionUser, auction)
  const oweTotals = {total: 0}

  if (!oweItems || oweItems.unpaid.length === 0) return oweTotals

  oweItems.unpaid.forEach((unpaidAmount) => {

    if (unpaidAmount.ItemId) {
      if (oweTotals['bidItems']) oweTotals['bidItems'] += unpaidAmount.CurrentBid
      else oweTotals['bidItems'] = unpaidAmount.CurrentBid 
      oweTotals['total'] += unpaidAmount.CurrentBid
    }
    else if (unpaidAmount.FixedItemId) {
      const fixedAmount = (unpaidAmount.MyAmountPurchased * unpaidAmount.PurchasePrice)
      if (oweTotals['fixedItems']) oweTotals['fixedItems'] += fixedAmount
      else oweTotals['fixedItems'] = fixedAmount 
      oweTotals['total'] += fixedAmount
    } 
    else if (unpaidAmount.Donation) {
      if (oweTotals['donations']) oweTotals['donations'] += unpaidAmount.Donation
      else oweTotals['donations'] = unpaidAmount.Donation 
      oweTotals['total'] += unpaidAmount.Donation
    } 
  })

  return oweTotals
}

// checks to see if the user won any bid items, purchased any fixed items, or made a donation
// essentially returns if they ever owed money for the auction
// returns true if it finds anything they would owe for
export const userHasCharge = (auctionUser, auction) => {
  const userId = auctionUser?.UserId
  if (!userId || !auction) return false

  const userAuction = auctionUser?.MyAuctions?.find((ele) => ele.AuctionId === auction.AuctionId)
  if (userAuction?.DonationTotal > 0) return true

  const hasFixedItemCharge = (auction.FixedItems || []).some((fixedItem) => {
    if (fixedItem?.MyAmountPurchased > 0) return true

    const purchasedQuantity = (fixedItem.Purchases || []).reduce((sum, purchase) => {
      if (purchase?.UserId !== userId) return sum
      return sum + (purchase.Quantity || 0)
    }, 0)

    return purchasedQuantity > 0
  })

  if (hasFixedItemCharge) return true

  const hasBidItemCharge = (auction.Items || []).some((item) => item.CurrentHighBidder === userId)
  if (hasBidItemCharge) return true

  return false
}
